'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.start = start;
exports.stop = stop;
exports.makeMonitor = makeMonitor;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reduxSaga = require('redux-saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* injects from baggage-loader */

var debug = require('debug')('metapro:monitor');

var START = Symbol();
var STOP = Symbol();
var ACTION = Symbol();
var ARGS = Symbol();

function start() {
  var _ref;

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _ref = {}, _defineProperty(_ref, ACTION, START), _defineProperty(_ref, ARGS, args), _ref;
}

function stop() {
  return _defineProperty({}, ACTION, STOP);
}

function makeMonitor(_ref3) {
  var task = _ref3.task;
  var event = _ref3.event;
  var mapEvent = _ref3.mapEvent;

  (0, _invariant2.default)(typeof task === 'function', 'makeMonitor task param must be a function');
  (0, _invariant2.default)(typeof mapEvent === 'function', 'makeMonitor task param must be a function');

  var name = task.name;

  return regeneratorRuntime.mark(function monitor(getState) {
    var process, processArgs, result, action;
    return regeneratorRuntime.wrap(function monitor$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            debug('%s starts', name);

            process = null;
            processArgs = [];

          case 3:
            if (!true) {
              _context.next = 32;
              break;
            }

            _context.next = 6;
            return event;

          case 6:
            result = _context.sent;
            action = mapEvent(result, getState);


            (0, _invariant2.default)(action && action[ACTION], 'mapEvent must return start(...) or stop()');

            if (!(action[ACTION] === START)) {
              _context.next = 23;
              break;
            }

            if (!process) {
              _context.next = 17;
              break;
            }

            if (_lodash2.default.isEqual(processArgs, action[ARGS])) {
              _context.next = 17;
              break;
            }

            debug('%s cancels task due to args change', name);
            _context.next = 15;
            return (0, _reduxSaga.cancel)(process);

          case 15:
            process = null;
            processArgs = [];

          case 17:
            if (process) {
              _context.next = 23;
              break;
            }

            processArgs = action[ARGS];
            debug.apply(undefined, ['%s forks with', name].concat(_toConsumableArray(processArgs)));
            _context.next = 22;
            return _reduxSaga.fork.apply(undefined, [task].concat(_toConsumableArray(processArgs)));

          case 22:
            process = _context.sent;

          case 23:
            if (!(action[ACTION] === STOP)) {
              _context.next = 30;
              break;
            }

            if (!process) {
              _context.next = 30;
              break;
            }

            debug('%s cancels task due to stop action', name);
            _context.next = 28;
            return (0, _reduxSaga.cancel)(process);

          case 28:
            process = null;
            processArgs = [];

          case 30:
            _context.next = 3;
            break;

          case 32:
          case 'end':
            return _context.stop();
        }
      }
    }, monitor, this);
  });
}


//////////////////
// WEBPACK FOOTER
// ./app/sagas/makeWatcher.js
// module id = 634
// module chunks = 1